import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "@emotion/react/jsx-runtime";
import { css } from "@emotion/react";
import styled from "@emotion/styled";
import { ButtonWithFooter } from "../ButtonWithFooter";
import { Detail } from "./Detail";
import { BoltIcon, ConnectDots, LockIcon, SolanaIcon } from "./icons";
export const WalletStepIntro = ({ appName, appIcon, onContinue, }) => {
    return (_jsxs(Wrapper, { children: [_jsx(AppIconsWrapper, { children: _jsxs(AppIcons, { children: [_jsx(SolanaIcon, {}), _jsx(ConnectDots, {}), _jsx("div", { css: css `
              width: 48px;
              height: 48px;
              & > img,
              & > svg {
                width: 100%;
                height: 100%;
              }
            `, children: appIcon })] }) }), _jsxs(Instruction, { children: ["To use ", appName, ", you need to connect a ", _jsx("strong", { children: "Solana" }), " wallet."] }), _jsxs(DetailsWrapper, { children: [_jsx(Detail, { icon: _jsx(LockIcon, {}), title: "You control your crypto", description: "Using a non-custodial wallet enables you to control your crypto without having to trust third parties." }), _jsx(Detail, { icon: _jsx(BoltIcon, {}), title: "Transact quickly and cheaply", description: "Solana's scalability ensures transactions remain less than $0.01 and at lightning fast speeds." })] }), _jsx(ButtonWithFooter, { id: "walletKit_intro_continue", onClick: onContinue, footer: _jsxs(_Fragment, { children: ["First time using Solana?", " ", _jsx("a", { href: "https://learn.goki.so", target: "_blank", rel: "noreferrer noopener", children: "Learn more" })] }), children: "Continue" })] }));
};
const Wrapper = styled.div `
  padding: 28px;
  padding-top: 33px;
`;
const AppIcons = styled.div `
  display: grid;
  grid-template-columns: 48px 1fr 48px;
  grid-column-gap: 20px;
  align-items: center;
  width: 192px;
`;
const Instruction = styled.h2 `
  font-weight: normal;
  margin-top: 27px;
  font-size: 24px;
  line-height: 30px;
  text-align: center;
  letter-spacing: -0.02em;
  color: #000000;
`;
const DetailsWrapper = styled.div `
  margin-top: 92px;
  display: grid;
  grid-row-gap: 28px;
`;
const AppIconsWrapper = styled.div `
  width: 100%;
  display: flex;
  justify-content: center;
`;
//# sourceMappingURL=index.js.map